import { useRead, ReadState, isCreators } from "@/components/LoadingStates";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CREATOR_DIALOG_CLASS } from "@/components/AddCreatorDialog";

export default function CompareCreatorPicker({ creatorId, children }) {
  const [open, setOpen] = useState(false);
  const creatorsRead = useRead(open ? "/creators" : null, isCreators, creatorId);
  const creators = creatorsRead.data || [];
  const [selected, setSelected] = useState("");
  const loading = creatorsRead.status === "loading";
  const error = creatorsRead.status === "error" || creatorsRead.status === "unavailable";
  const navigate = useNavigate();

  const changeOpen = useCallback((next) => {
    if (next) setSelected("");
    setOpen(next);
  }, []);
  const candidates = creators.filter((creator) => creator.id !== creatorId);
  const valid = selected && selected !== creatorId && candidates.some((creator) => creator.id === selected);
  const compare = () => {
    if (loading || error || !valid) return;
    setOpen(false);
    navigate(`/compare?${new URLSearchParams({ a: creatorId, b: selected })}`);
  };

  return (
    <Dialog open={open} onOpenChange={changeOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className={CREATOR_DIALOG_CLASS} data-testid="compare-creator-picker">
        <DialogHeader>
          <DialogTitle>Compare with…</DialogTitle>
          <DialogDescription>Choose another creator for a head-to-head comparison.</DialogDescription>
        </DialogHeader>
        <ReadState read={creatorsRead} scope="compare-creator-candidates" empty={!candidates.length} title="Aucun autre créateur disponible" primaryCta={{ label: "Consulter les créateurs", to: "/creators" }}>
          <div className="space-y-1.5">
            <label htmlFor="comparison-creator" className="text-sm font-medium">Creator</label>
            <Select value={selected} onValueChange={setSelected}>
              <SelectTrigger id="comparison-creator" data-testid="compare-creator-select"><SelectValue placeholder="Choose a creator…" /></SelectTrigger>
              <SelectContent>
                {candidates.map((creator) => <SelectItem key={creator.id} value={creator.id} data-testid={`compare-creator-option-${creator.id}`}>{creator.name} · {creator.handle} · {creator.platform}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </ReadState>
        <Button onClick={compare} disabled={loading || !!error || !valid} data-testid="compare-creator-confirm" className="w-full sm:w-auto">Compare</Button>
      </DialogContent>
    </Dialog>
  );
}
